import React from 'react';
import { KPICard, KPICardBoth } from '../KPICard';
import { ScrollText, Ship, CheckSquare, AlertCircle, Clock3 } from 'lucide-react';

const KPIStats = ({ projects, ships, dashboardSummary, setShowActiveShipsModal }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <KPICardBoth
        icon1={<ScrollText size={40} className="text-indigo-600" />}
        title1="Total Projects"
        value1={projects.length || 0}
        bgColor="bg-purple-200"
        icon2={<Ship size={40} className="text-indigo-600" />}
        title2="Active Ships"
        value2={ships.length || 0}
        onClick2={() => setShowActiveShipsModal(true)}
      />
      <KPICard
        icon={<CheckSquare size={40} className="text-green-600" />}
        title="Completed Tasks"
        value={dashboardSummary?.["Completed Tasks"] || 0}
        bgColor="bg-green-200"
      />
      <KPICard
        icon={<AlertCircle size={40} className="text-yellow-600" />}
        title="In-line Tasks"
        value={dashboardSummary?.["In-line Tasks"] || 0}
        trendUp={false}
        bgColor="bg-yellow-200"
      />
      <KPICard
        icon={<Clock3 size={40} className="text-red-600" />}
        title="Overdue Tasks"
        value={dashboardSummary?.["Overdue Tasks"] || 0}
        trendUp={true}
        bgColor="bg-red-200"
      />
    </div>
  );
};

export default KPIStats;